import React, { useEffect, useState } from 'react';
import {
  approveTenantRequest,
  getTenantRequestDetail,
  processTenantRequest,
  tenantActivation
} from '../../../api/sportaloka-client';
import { useNavigate, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import RejectTenantModal from '../components/RejectTenantModal';
import TenantFee from '../components/TenantFee';

const TenantDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState('information');
  const navigate = useNavigate();

  const getData = async () => {
    setLoading(true);
    const response = await getTenantRequestDetail(id);
    const responseData = response.data.data;
    setData({ ...responseData, status: getStatusObject(responseData.status) });
    setLoading(false);
  };

  const handleProcess = async () => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Status permintaan tenant akun diubah menjadi sedang di proses.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setSubmitLoading(true);
          await processTenantRequest(id);
          Swal.fire({
            title: 'Berhasil!',
            text: `Berhasil mengubah status permintaan tenant`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          await getData();
          setSubmitLoading(false);
        } catch (error) {
          setSubmitLoading(false);
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
        }
      }
    });
  };

  const handleApprove = async () => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Setelah ini user akan menerima email dan dapat masuk ke aplikasi sportaloka.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setSubmitLoading(true);
          await approveTenantRequest(id);
          navigate('/tenants');
          Swal.fire({
            title: 'Berhasil!',
            text: `Berhasil mengubah status permintaan tenant`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          await getData();
          setSubmitLoading(false);
        } catch (error) {
          setSubmitLoading(false);
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
        }
      }
    });
  };

  const handleActivation = async () => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Apakah anda yakin ingin mengubah status tenant?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setSubmitLoading(true);
          await tenantActivation(id);
          navigate('/tenants');
          Swal.fire({
            title: 'Berhasil!',
            text: `Berhasil mengubah status tenant`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          await getData();
          setSubmitLoading(false);
        } catch (error) {
          setSubmitLoading(false);
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
        }
      }
    });
  };

  const getStatusObject = (status) => {
    switch (status) {
      case 'NEW_REQUEST':
        return {
          color: 'yellow-4',
          textColor: 'yellow-3',
          label: 'NEW',
          value: status
        };
      case 'APPROVED':
        return {
          color: 'green-1',
          textColor: 'green-2',
          label: 'ACTIVE',
          value: status
        };
      case 'INACTIVE':
        return {
          color: 'red-3',
          textColor: 'red-1',
          label: 'INACTIVE',
          value: status
        };
      case 'REJECTED':
        return {
          color: 'red-3',
          textColor: 'red-1',
          label: 'REJECTED',
          value: status
        };
      default:
        return {
          color: 'blue-1-05',
          textColor: 'blue-1',
          label: 'IN PROGRESS',
          value: status
        };
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Detail Tenant</h1>
          {!loading && (
            <div className="d-flex">
              {data.status.value === 'NEW_REQUEST' && (
                <button
                  disabled={submitLoading}
                  type="button"
                  className="button -md h-50 bg-blue-1 text-white"
                  onClick={handleProcess}>
                  {submitLoading ? 'Mohon tunggu...' : 'Proses Permintaan'}
                </button>
              )}
              {(data.status.value === 'APPROVED' || data.status.value === 'INACTIVE') && (
                <button
                  disabled={submitLoading}
                  type="button"
                  className={`button -md h-50 text-white ${data.status.value === 'APPROVED' ? 'bg-red-2' : 'bg-blue-1'} text-white`}
                  onClick={handleActivation}>
                  {submitLoading && 'Mohon tunggu...'}
                  {!submitLoading &&
                    `${data.status.value === 'APPROVED' ? 'Nonaktifkan Tenant' : 'Aktifkan Tenant'}`}
                </button>
              )}
              {data.status.value === 'WAITING_FOR_APPROVAL' && (
                <div className="d-flex">
                  <button
                    disabled={submitLoading}
                    type="button"
                    className="button -md h-50 bg-danger text-white mr-20"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal">
                    Tolak Permintaan
                  </button>

                  <button
                    disabled={submitLoading}
                    type="button"
                    className="button -md h-50 bg-blue-1 text-white"
                    onClick={handleApprove}>
                    {submitLoading ? 'Mohon tunggu...' : 'Setujui Permintaan'}
                  </button>
                  <RejectTenantModal onFetchData={getData} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="col-12">
        <div className="rounded-4 bg-white shadow-3 mt-20">
          <ul className="tabs-nav">
            <li
              onClick={() => setSelectedTab('information')}
              className={`${selectedTab === 'information' && 'active'}`}>
              Informasi Tenant
            </li>
            <li
              onClick={() => setSelectedTab('fee-config')}
              className={`${selectedTab === 'fee-config' && 'active'}`}>
              Konfigurasi Fee
            </li>
          </ul>
          <div className="px-20 py-10">
            {loading && <p className="text-center text-dark fw-600">Loading...</p>}
            {!loading && selectedTab === 'information' && (
              <div>
                <table className="table">
                  <tbody>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Nama Perusahaan
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">{data.company_name ?? '-'}</td>
                    </tr>

                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Nama Site
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">{data.site_name}</td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Alamat Site
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">{data.site_address}</td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Nama Owner
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">
                        {data.users[0] ? data.users[0].fullname : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Alamat Email
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">
                        {data.users[0] ? data.users[0].email : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Nomor Handphone
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">
                        {data.users[0] ? data.users[0].phone_number : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Kuota Harian
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">{data.daily_quota}</td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Status
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">
                        <div
                          className={`rounded-100 py-1 d-inline px-10 text-center col-12 text-12 fw-600 bg-${data.status.color} text-${data.status.textColor}`}>
                          {data.status.label}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Tanggal dibuat
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">
                        {format(new Date(data.created_at), 'dd/MM/yyyy hh:mm')}
                      </td>
                    </tr>
                    <tr>
                      <td width="30%" className="fw-500 py-10 px-5 text-dark">
                        Update Terakhir
                      </td>
                      <td width="5%" className="py-10 px-5 text-dark">
                        :
                      </td>
                      <td className="py-10 px-5 text-dark">
                        {format(new Date(data.updated_at), 'dd/MM/yyyy hh:mm')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {!loading && selectedTab === 'fee-config' && <TenantFee />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantDetail;
